import script from "./EditPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditPanel.vue?vue&type=script&lang=ts&setup=true"

import "./EditPanel.vue?vue&type=style&index=0&id=6d3b68c2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d3b68c2"]])

export default __exports__